"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Player = void 0;
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var Player = function (_a) {
    var channel = _a.channel, onSelectedTimestamp = _a.onSelectedTimestamp, video = _a.video, setVideo = _a.setVideo, selectingTimestamp = _a.selectingTimestamp;
    var _b = react_1.useState(0), timestamp = _b[0], setTimestamp = _b[1];
    function getPlayerClassname() {
        return __spreadArray([
            'storybook-producer-player'
        ], (selectingTimestamp ? ['storybook-producer-selecting-timestamp'] : [])).join(' ');
    }
    function handleSelectTimestamp() {
        // Seek to live and resume playback
        jwplayer().seek(-jwplayer().getDuration());
        jwplayer().play();
        // Callback
        onSelectedTimestamp(timestamp);
    }
    react_1.useEffect(function () {
        // Avoid errors while jwplayer not initiated
        if ("object" !== typeof jwplayer()
            && !jwplayer().hasOwnProperty('getDuration'))
            return;
        if (selectingTimestamp) {
            jwplayer().pause();
            // Set initial timestamp
            setTimestamp(jwplayer().getCurrentTime());
            // Update after scrubber dropped
            jwplayer().on('seeked', function () {
                setTimestamp(jwplayer().getCurrentTime());
            });
        }
    }, [jwplayer, selectingTimestamp]);
    return (react_1.default.createElement("div", { className: getPlayerClassname() },
        react_1.default.createElement("div", { className: 'storybook-producer-player-wrapper' },
            react_1.default.createElement(storybook_1.Players.Player, { channel: channel, autoplay: true, className: 'storybook-producer-player-video', hls: video.hls, playable: true, video: video, setVideo: function (video) { return setVideo(video); } }),
            selectingTimestamp &&
                react_1.default.createElement("div", { className: "storybook-producer-timestamp-selector" },
                    react_1.default.createElement("p", null, "Selecteer in de player het moment dat je wilt annoteren"),
                    react_1.default.createElement(storybook_1.Buttons.Button, { onClick: function () { return handleSelectTimestamp(); }, type: "secondary" }, "Akkoord")))));
};
exports.Player = Player;
exports.Player.defaultProps = {
    onSelectedTimestamp: function () { },
    setVideo: function () { },
    selectingTimestamp: false
};
